import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes, volumePages } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-156" data-mp="1itgx9h0s5zo8">
      <div className="mx-auto max-w-6xl px-4" data-id="element-157" data-mp="1dy1np19t2pxm">
        <div className="text-center" data-id="element-158" data-mp="2bjyzkftojx0l">
          <span className="bg-ivory inline-flex items-center gap-2 rounded-full border border-teal/25 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-teal" data-id="element-159" data-mp="2bixnq94ub6ht">
            <LibraryBigIcon className="h-4 w-4" data-id="element-160" data-mp="21ljf2vp5rm02" /> Los {totalVolumes} tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-161" data-mp="1wnho7olhqie1">
            Una guía completa por cada dimensión de la Museología argentina
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="l71hqkrwzc3b">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="bg-ivory relative flex flex-col rounded-2xl border border-line p-6 text-ink shadow-card" data-id="element-163" data-mp="1nuleol1xv684" data-mpi={index}>
                <div className="flex items-start justify-between gap-4" data-id="element-164" data-mp="14xk8iwwnf02l">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-deep text-gold" data-id="element-165" data-mp="q7w7lwsdq3fe">
                    <Icon className="h-6 w-6" data-id="element-166" data-mp="v5xn67qljkm4" />
                  </span>
                  <span className="font-display text-2xl font-bold text-line" data-id="element-167" data-mp="h6xy4yz693pf">Tomo {module.number}</span>
                </div>
                <h3 className="mt-5 text-xl font-bold text-ink" data-id="element-168" data-mp="l6owpouxwo4i">{module.title}</h3>
                <p className="mt-2 text-sm font-semibold italic text-gold" data-id="element-169" data-mp="2nux7lk4pm0qw">{module.subtitle}</p>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-170" data-mp="2j2nank56g0f4">{module.description}</p>
                <p className="mt-4 flex-1 rounded-xl border border-teal/20 bg-aquaSoft p-3 text-sm leading-relaxed text-teal" data-id="element-171" data-mp="2e5docdd344vi">
                  <b className="font-extrabold" data-id="element-172" data-mp="2972ew3qpbwdt">Resultado: </b>
                  {module.result}
                </p>
                <div className="mt-5 flex items-center justify-between gap-4 border-t border-line pt-4" data-id="element-173" data-mp="36qndvjjodjal">
                  <p className="text-[10px] font-extrabold uppercase tracking-[.1em] text-muted" data-id="element-174" data-mp="2wutr77c8s9f3">{module.tags}</p>
                  <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-goldSoft px-3 py-1 text-xs font-extrabold text-alert" data-id="element-175" data-mp="2sti8llrscoge">
                    <FileTextIcon className="h-3.5 w-3.5" data-id="element-176" data-mp="1lh821m6du7tk" /> {module.pages} pág.
                  </span>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="bg-stage-deep mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-gold/40 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-177" data-mp="3t2ztio0bo9b2">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-178" data-mp="5wgvyq5umoi8">Total de la colección principal</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-179" data-mp="ao7al8btjyfg">
            {totalVolumes} tomos <span className="mx-2 text-gold" data-id="element-180" data-mp="fm0ge097mqf7">·</span> {volumePages} páginas
          </p>
        </div>
      </div>
    </section>;
}